import React, { useState } from "react";
import history from "../../history";
import scanImg from "../../../src/images/scan.png";
import { getRedirectUriNWH, pdfLink } from "../../urlConstants";
import { Dropdown, DropdownItem, DropdownMenu } from "semantic-ui-react";
import { MobileView } from "react-device-detect";
import { useSelector, useDispatch } from "react-redux";
import { createMedia } from "@artsy/fresnel";
import { retrunToMol } from "../../views/Login/actions";
import { CLAIMS_BASE_API } from "../../urlConstants";
import restUtils from "../../utils/restUtils";
import { Modal, ModalContent } from "semantic-ui-react";
 
// Media breakpoints
export const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    sm: 0,
    md: 768,
    lg: 1024,
    xl: 1192,
  },
});
 
// Dummy 
//const checkShowPopup = async () => {
  //return { data: 2 }; 
//};
 
const HeroBar = () => {
  const currentPath = history.location.pathname;
  const [confirmPopup, setConfirmPopup] = useState({
    visible: false,
    action: null,
  });
  const dispatch = useDispatch();
  const { userName, storeId } = useSelector((state) => state.SessionReducer);
  console.log(userName);
  const checkShowPopup = async () => {
    try {
      const res = await restUtils.getDataWithBearer(
        `${CLAIMS_BASE_API}/${storeId}/GetPendingClaimItemsGreaterthan48HRS?createdBy=${userName.replace("@","")}`
      );
      
      console.log(res.data);
      return res?.data;
    } catch (err) {
      console.error("Popup check API failed:", err);
      return 0;
    }
  };
  const redirectToScan = () => {
    history.push("/scan");
  };
 
  const downloadPdf = () => {
    const pdfUrl = pdfLink();
    const link = document.createElement("a");
    link.href = pdfUrl;
link.download = "qr_code.pdf";
    document.body.appendChild(link);
link.click();
    document.body.removeChild(link);
  };
 
  const handlePopupAction = async (action) => {
    if (currentPath === "/claimConfirmation") {
      const result = await checkShowPopup();
      console.log("result of herobar",result);
      if (result > 0) {
        setConfirmPopup({ visible: true, action });
        return;
      }
    }
    action();
  };
 
  const confirmRedirect = () => {
    if (confirmPopup.action) {
      confirmPopup.action();
    }
    setConfirmPopup({ visible: false, action: null });
  };
 
  const cancelRedirect = () => {
    setConfirmPopup({ visible: false, action: null });
  };
 
  return (
    <div className="heroHeader ui stackable grid zero-margin" computer={3} tablet={2}>
      <div className="heroHeaderWrapper gridContainer">
        <div className="header-top-left">
          <div
            className="cursor_p headerLogoImg"
            onClick={() =>
              handlePopupAction(() => dispatch(retrunToMol(getRedirectUriNWH())))
            }
          ></div>
          <h3>Claims</h3>
        </div>
        <div className="header_icons header-top-right">
          <div className="headerNameStore">
            <p className="name_card">Hello, {userName}</p>
            <p> Store# {storeId}</p>
          </div>
          <div className="userInfoWrapper">
            <div className="header_user_icons">
              <span onClick={downloadPdf}>
                <i className="far fa-qrcode"></i>
              </span>
              <MobileView className="scanBarcode">
                <img src={scanImg} alt={"scan"} onClick={redirectToScan} />
              </MobileView>
              <Dropdown className="userDropDownMenu" text={""} simple>
                <DropdownMenu>
                  <DropdownItem>
                    <p
                      onClick={() =>
                        handlePopupAction(() =>
                          dispatch(retrunToMol(getRedirectUriNWH()))
                        )
                      }
                    >
                      Return to NETWAREHOUSE
                    </p>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
      {confirmPopup.visible && (
        <Modal className="deleteItemPopup" open={confirmPopup.visible}>
          <ModalContent>
          <h4>You have Pending Items that are not submitted yet. <br/> <br/>Are you sure you want to continue?</h4>
            <div>
              <button className="ui button" onClick={confirmRedirect}>
                Yes
              </button>
              <button className="ui button redBtn" onClick={cancelRedirect}>
                No
              </button>
            </div>
          </ModalContent>
        </Modal>
      )}
    </div>
  );
};
 
export default HeroBar;